import { addResolver, resolve } from "./resolver";

export {
    addResolver,
    resolve
};
